module.exports = __webpack_public_path__ + "static/media/tables.45831926.svg";